module.exports = __webpack_public_path__ + "img/kshop.72b5cc2a.png";